import { createSlice } from "@reduxjs/toolkit";
import axios from 'utils/axios';
import { dispatch } from '../index';
import { FormData } from "types/form";

const initialState: FormData = {
    follow_up_status:[{title: "Open",value: "open"},{title: "Scheduled",value: "scheduled"},{title: "Completed",value: "completed"},{title: "Cancelled",value: "cancelled"}],
    follow_up_type:[{title: "Call",value: "call"},{title: "SMS",value: "sms"},{title: "Meeting",value: "meeting"},{title: "Email",value: "email"},{title: "Other",value: "other"}],
    project_status:[{title: "Not Started",value: "pending"},{title: "In Progress",value: "progress"},{title: "On Hold",value: "hold"},{title: "Snagging",value: "snagging"},{title: "Completed",value: "completed"},{title: "Closed",value: "closed"},{title: "Cancelled",value: "cancelled"}],
    lead_status:[{title: "Pending",value: "pending"},{title: "Acquired",value: "acquired"},{title: "Not acquired",value: "unacquired"}],
    task_priority:[{title: "Low",value: "low"},{title: "Medium",value: "medium"},{title: "High",value: "high"},{title: "Urgent",value: "urgent"}],
    task_status:[{title: "Pending",value: "pending"},{title: "Started",value: "started"},{title: "Ended",value: "ended"}],
    invoice_status:[{title: "Paid",value: "paid"},{title: "Unpaid",value: "unpaid"},{title: "Part Paid",value: "partial"},{title: "cancelled",value: "cancelled"},{title: "Error",value: "error"}],
    purchase_status:[{title: "Paid",value: "paid"},{title: "Unpaid",value: "unpaid"},{title: "cancelled",value: "cancelled"},{title: "Error",value: "error"}],
    material_status:[{title: "Pending",value: "pending"},{title: "Ordered",value: "ordered"},{title: "Delivered to Site",value: "delivered"}],
    transaction_status:[{title: "Pending",value: "pending"},{title: "Success",value: "success"},{title: "Scheduled",value: "scheduled"}],
    quotation_status:[{title: "Created",value: "created",hidden:false},{title: "Sent",value: "sent",hidden:false},{title: "Viewed",value: "viewed",hidden:true},{title: "Accepted",value: "accepted",hidden:false},{title: "Invoiced",value: "invoiced",hidden:false},{title: "Declined",value: "declined",hidden:true}],
    survey_materials:[
        {code:'survey_material_01',name:'Roll & Stroll',quantity:0,cost:0},
        {code:'survey_material_02',name:'Corri-board',quantity:0,cost:0},
        {code:'survey_material_03',name:'Thistlebond',quantity:0,cost:0},
        {code:'survey_material_04',name:'½ Plasterboard Standard',quantity:0,cost:0},
        {code:'survey_material_05',name:'½ Plasterboard Green',quantity:0,cost:0},
        {code:'survey_material_06',name:'Skim Coat Plaster',quantity:0,cost:0},
        {code:'survey_material_07',name:'Bonding Compound Mini Mesh/Beads',quantity:0,cost:0},
        {code:'survey_material_08',name:'Paint',quantity:0,cost:0},
        {code:'survey_material_09',name:'Pop in Vent',quantity:0,cost:0},
        {code:'survey_material_10',name:'4" Ducting',quantity:0,cost:0},
        {code:'survey_material_11',name:'PVC Claddin 250mm x 2400mm',quantity:0,cost:0},
        {code:'survey_material_12',name:'3x1½" x 8ft Rough',quantity:0,cost:0},
        {code:'survey_material_13',name:'2x2" x 16ft Rough',quantity:0,cost:0},
        {code:'survey_material_14',name:'2x1" x 16ft Rough',quantity:0,cost:0},
        {code:'survey_material_15',name:'WBP Ply 18mm',quantity:0,cost:0},
        {code:'survey_material_16',name:'OSB 18mm',quantity:0,cost:0},
        {code:'survey_material_17',name:'1200mm x 1200mm Cement Boards',quantity:0,cost:0},
        {code:'survey_material_18',name:'1200mm x 1200mm Magnessium Boards',quantity:0,cost:0},
        {code:'survey_material_19',name:'Collated Screws',quantity:0,cost:0},
        {code:'survey_material_20',name:'General Screws',quantity:0,cost:0},
        {code:'survey_material_21',name:'Spray Foam',quantity:0,cost:0},
        {code:'survey_material_22',name:'Insulated Board',quantity:0,cost:0},
        {code:'survey_material_23',name:'Mashroom Fixings',quantity:0,cost:0},
        {code:'survey_material_24',name:'Tec 7',quantity:0,cost:0},
        {code:'survey_material_25',name:'Primer',quantity:0,cost:0},
        {code:'survey_material_26',name:'Architrave',quantity:0,cost:0},
        {code:'survey_material_27',name:'Door Stop',quantity:0,cost:0},
        {code:'survey_material_28',name:'Door Frame',quantity:0,cost:0},
        {code:'survey_material_29',name:'Door',quantity:0,cost:0},
        {code:'survey_material_30',name:'Handle/Hinge/Lock',quantity:0,cost:0},
        {code:'survey_material_31',name:'Skirting Board',quantity:0,cost:0},
        {code:'survey_material_32',name:'Silicon',quantity:0,cost:0},
    ],
    survey_suite_materials:[
      {code:'survey_suite_material_01',name:'Bath',quantity:0,cost:0},
      {code:'survey_suite_material_02',name:'Bath Taps',quantity:0,cost:0},
      {code:'survey_suite_material_03',name:'Bath Panel',quantity:0,cost:0},
      {code:'survey_suite_material_04',name:'Bath Screen',quantity:0,cost:0},
      {code:'survey_suite_material_05',name:'Shower',quantity:0,cost:0},
      {code:'survey_suite_material_06',name:'Tray',quantity:0,cost:0},
      {code:'survey_suite_material_07',name:'Marmex Board',quantity:0,cost:0},
      {code:'survey_suite_material_08',name:'Wetroom Screen',quantity:0,cost:0},
      {code:'survey_suite_material_09',name:'Quadrant Shower Door',quantity:0,cost:0},
      {code:'survey_suite_material_10',name:'End Glass Pannel',quantity:0,cost:0},
      {code:'survey_suite_material_11',name:'Suare Corner Entry Doors',quantity:0,cost:0},
      {code:'survey_suite_material_12',name:'Pivote Doors',quantity:0,cost:0},
      {code:'survey_suite_material_13',name:'Bifold Doors',quantity:0,cost:0},
      {code:'survey_suite_material_14',name:'Slider Door',quantity:0,cost:0},
      {code:'survey_suite_material_15',name:'Flipper Pannel',quantity:0,cost:0},
      {code:'survey_suite_material_16',name:'Inline Mixer',quantity:0,cost:0},
      {code:'survey_suite_material_17',name:'High Lever Pan Cistern and Seat',quantity:0,cost:0},
      {code:'survey_suite_material_18',name:'Fold Away Drop Grab Rail',quantity:0,cost:0},
      {code:'survey_suite_material_19',name:'Pan/Cistern Seat',quantity:0,cost:0},
      {code:'survey_suite_material_20',name:'Basin & Ped',quantity:0,cost:0},
      {code:'survey_suite_material_21',name:'Vanity Unit/Basin',quantity:0,cost:0},
      {code:'survey_suite_material_22',name:'Basin Taps',quantity:0,cost:0},
      {code:'survey_suite_material_23',name:'Radiators',quantity:0,cost:0},
      {code:'survey_suite_material_24',name:'Towel Warmer',quantity:0,cost:0},
      {code:'survey_suite_material_25',name:'Bidet Tap',quantity:0,cost:0},
      {code:'survey_suite_material_26',name:'Wc Frame etc',quantity:0,cost:0},
      {code:'survey_suite_material_27',name:'Mirror',quantity:0,cost:0},
      {code:'survey_suite_material_28',name:'Toilet Roll Holder',quantity:0,cost:0},
      {code:'survey_suite_material_29',name:'Towel Holder',quantity:0,cost:0},
      {code:'survey_suite_material_30',name:'½ Height doors and curtains',quantity:0,cost:0},
      {code:'survey_suite_material_31',name:'Anti Scalp Shower valve',quantity:0,cost:0},
      {code:'survey_suite_material_32',name:'Triton T90 Safe Guard Shower Unit',quantity:0,cost:0},
      {code:'survey_suite_material_33',name:'Fold Down Shower Seat with Padded back arms & legs',quantity:0,cost:0},
      {code:'survey_suite_material_34',name:'Grap Rails',quantity:0,cost:0},
      {code:'survey_suite_material_35',name:'Basin',quantity:0,cost:0},
      {code:'survey_suite_material_36',name:'Toilet Brush',quantity:0,cost:0},
      {code:'survey_suite_material_37',name:'Robe Hook',quantity:0,cost:0},
      {code:'survey_suite_material_38',name:'Tall Unit',quantity:0,cost:0},
     
  ],
  survey_tiling_materials:[
      {code:'survey_tiling_material_01',name:'Primer',quantity:0,cost:0},
      {code:'survey_tiling_material_02',name:'Tanking Kit',quantity:0,cost:0},
      {code:'survey_tiling_material_03',name:'Tanking Tape',quantity:0,cost:0},
      {code:'survey_tiling_material_04',name:'Tile trims',quantity:0,cost:0},
      {code:'survey_tiling_material_05',name:'Slow Set Adhesive',quantity:0,cost:0},
      {code:'survey_tiling_material_06',name:'Rapid Set Adhesive',quantity:0,cost:0},
      {code:'survey_tiling_material_07',name:'P4 Ardex Promer',quantity:0,cost:0},
      {code:'survey_tiling_material_08',name:'Wall Tiles',quantity:0,cost:0},
      {code:'survey_tiling_material_09',name:'Floor Tiles',quantity:0,cost:0},
      {code:'survey_tiling_material_10',name:'Teature Tiles',quantity:0,cost:0},

      {code:'survey_tiling_material_11',name:'Quartz',quantity:0,cost:0},
      {code:'survey_tiling_material_12',name:'Wall & Floor Grout',quantity:0,cost:0},
      {code:'survey_tiling_material_13',name:'Silicone',quantity:0,cost:0},
      {code:'survey_tiling_material_14',name:'Leveling Compound',quantity:0,cost:0},
      {code:'survey_tiling_material_15',name:'FA20',quantity:0,cost:0},
      {code:'survey_tiling_material_16',name:'Leveling Clips',quantity:0,cost:0},
      {code:'survey_tiling_material_17',name:'Door Bars',quantity:0,cost:0},      
  ],
  survey_electrical_materials:[
    {code:'survey_electrical_material_01',name:'Immersion Supply & kit',quantity:0,cost:0},
    {code:'survey_electrical_material_02',name:'Mirror Light Supply & kit',quantity:0,cost:0},
    {code:'survey_electrical_material_03',name:'Wire Up Pump',quantity:0,cost:0},
    {code:'survey_electrical_material_04',name:'Immersion Time Clock Supply & Fit',quantity:0,cost:0},
    {code:'survey_electrical_material_05',name:'Under Floor Heating',quantity:0,cost:0},
  ],
  survey_pricing:[
    {code:'survey_pricing_01',name:'Skip/Rubbish Removal and Floor Protection',description:0,vat:0,cost:0},
    {code:'survey_pricing_02',name:'Supply and fit ceiling',description:0,vat:0,cost:0},
    {code:'survey_pricing_03',name:'Supply and fit Ceiling Lighting',description:0,vat:0,cost:0},
    {code:'survey_pricing_04',name:'Supply & Fit Fan & Natural Vent',description:0,vat:0,cost:0},
    {code:'survey_pricing_05',name:'Tile Allowance inc Delivery',description:0,vat:0,cost:0},
    {code:'survey_pricing_06',name:'Plumbing Fittings',description:0,vat:0,cost:0},
    {code:'survey_pricing_07',name:'Tiling Material Including Tanking Kit',description:0,vat:0,cost:0},
    // {code:'survey_pricing_08',name:'Building Material',description:0,vat:0,cost:0},
    {code:'survey_pricing_09',name:'T90 Supply & Fit',description:0,vat:0,cost:0},
    {code:'survey_pricing_10',name:'Pump Supply & Fit',description:0,vat:0,cost:0},
    {code:'survey_pricing_11',name:'Tiling Labour',description:0,vat:0,cost:0},
    {code:'survey_pricing_12',name:'Plumbing Labour',description:0,vat:0,cost:0},
    {code:'survey_pricing_13',name:'Renovating Labour',description:0,vat:0,cost:0},
    {code:'survey_pricing_14',name:'Strip Out Labour',description:0,vat:0,cost:0},
    {code:'survey_pricing_15',name:'First Fix Labour',description:0,vat:0,cost:0},
    {code:'survey_pricing_16',name:'Second Fix Labour',description:0,vat:0,cost:0},
  ],
  project_snagging:[]
  };
const formData = createSlice({
    name: 'form-data',
    initialState,
    reducers: {
     
  
      
    setFormsData(state, action) {
      state.follow_up_status=action.payload.data['follow_up_status']
    },

 

    }
  });

  export default formData.reducer;
  
  export function load(params:string[]=[]) {
    return async () => {
      try {
        if(params.length===0){
            params=Object.keys(initialState)
        }
        const response = await axios.post('forms',{data:params});
        dispatch(formData.actions.setFormsData(response.data));
      } catch (error) {
        // dispatch(formData.actions.hasError(error));
      }
    };
  }
